import { render, staticRenderFns } from "./subjects.vue?vue&type=template&id=7cc14616&"
import script from "./subjects.vue?vue&type=script&lang=js&"
export * from "./subjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports